import { Navigate, Route, Routes } from "react-router-dom";
import ProtectedRoute from "./_helper/constant/ProtectedRoute";
import { useCurrentRole } from "./_helper/constant/Permission";
// import { Suspense, lazy } from "react";

// import Main from "./components/user/main";
// import Config from "./components/admin/config/Config";
// import ManageTagTypes from "./components/admin/masters/tag_types/ManageTagTypes";
// import Bmi from "./calculators/Bmi";
// import IdealWeight from "./calculators/IdealWeight";
// import BodyFat from "./calculators/BodyFat";
// import CaloriesBurnied from "./calculators/CaloriesBurnied";
// import Adjustuserdetail from "./components/user/User-Detail/Adjustuserdetail";
// import Layout from "./components/admin/templete/view/Layout";
// import AddNewData from "./components/admin/modals/AddNewData";
// import JitsiComponent from "./components/video/video-consultation";
// import Setup from "./components/admin/setup/view/Setup";
// import Phonepe from "./components/payment/phonepe";

// Working components
import FrontDeskView from "./components/front_desk";
import Authentication from "./components/authentication/view/Authentication";
import Appointment from "./new_appointment/appoinment/views/Appointment";
import AvailibilityTest from "./components/admin/sidebar/views/AvailibilityTest";
import DrSetup from "./doctor_setup/views/DrSetup";
import InvoiceForm from "./credit_invoice/views/InvoiceForm";
import InvoiceMain from "./credit_invoice/views/InvoiceMain";
import CustomerSetupMain from "./doctor_setup/views/CustomerSetupMain";
import AllPatient from "./all-patient/pages/AllPatient";
import Records from "./all-patient/pages/Records";
import Dashboard from "./dashboard/pages/Dashboard";
import Notification from "./notification/pages/Notification";
import SomethingWentWrong from "./common_component/component/SomethingWentWrong";
import CustomFields from "./custom-fields/CustomFields";
// import Roles from "./roles_and_permissions/views/Roles";
// import EditRoles from "./roles_and_permissions/components/EditRoles";
// import CreateRoles from "./roles_and_permissions/components/CreateRoles";
// import UserTable from "./roles_and_permissions/views/UserTable";
// import UserCreateRoles from "./roles_and_permissions/components/UserCreateRoles";
// import GlobalFilter from "./common_component/component/GlobalFilter";
import ConsultationLeftBar from "./new_consultation/views/ConsultationLeftBar";
import Settings from "./settings/views/Settings";
import HelpCenter from "./settings/views/HelpCenter";
import HelpCenterForm from "./settings/views/HelpCenterForm";
import Tickets from "./settings/views/Tickets";
import MyNotes from "./myNotes/MyNotes";
// import AddInvestigation from "./new_consultation/component/AddInvestigation";
// import { popupTaskAtom, showPopupAtom } from "./_helper/constant/constant-atom";
// import { useAtom } from "jotai";
import RemainderPopup from "./myNotes/RemainderPopup";
// import Layout from "./myNotes/Layout";
// import { useEffect, useState } from "react";
import useReminder from "./hooks/useReminder";
// import InvoiceDetails from "./mobile_invoice/views/InvoiceDetails";
// import Invoice from "./mobile_invoice/views/Invoice";
// import Questionnaire from "./questionnaire/views/Questionnaire";
import Profile from "./components/editProfile/Profile";
import EmptyState from "./common_component/component/EmptyState";
import PatientRegistration from "./patient_registration/views/PatientRegistration";
import Emergency from "./emergency/views/Emergency";
import IpdManagement from "./ipd_management/views/IpdManagement";
import ProcedureMaster from "./procedure_master/views/ProcedureMaster";
import WardDetails from "./ipd_management/components/WardDetails";
import PatientDetailManagement from "./ipd_management/views/PatientDetailManagement";
import DischargeWorkflow from "./ipd_management/views/DischargeWorkflow";
import TreatmentTracker from "./ipd_management/components/TreatmentTracker";
// import Pharmacy from "./pharmacy/views/Pharmacy";
import VendorMaster from "./doctor_setup/views/VendorMaster";
import ItemMasterWrapper from "./doctor_setup/views/ItemMasterWrapper";
import PharmacyWrapper from "./Pharmacy/PharmacyWrapper";
import POSDashboard from "./Pharmacy/POS/POSDashboard";
import PharmacyOperationWrapper from "./pharmacy_operations/Wrapper/PharmacyOperationWrapper";
import CreateReceipt from "./pharmacy_operations/Inventory/CreateReceipt";
import ReceiptDetail from "./pharmacy_operations/Inventory/ReceiptDetail";
import PrescriptionDetail from "./pharmacy_operations/PrescriptionDetail/PrescriptionDetail";
import CreateBill from "./pharmacy_operations/CreateBilling/CreateBill";
import WorkflowSetup from "./WorkflowSetup/WorkflowSetup";
import WorkflowList from "./WorkflowSetup/WorkflowList";
import PharmacyForm from "./doctor_setup/components/warehouse_setup/PharmacyForm";
import ManageQuestionnaires from "./questionnaire/views/ManageQuestionnaires";
import QuestionnaireBuilder from "./questionnaire/views/QuestionnaireBuilder";
import QuestionnaireManager from "./questionnaire/views/QuestionnaireManager";
import UoM from "./doctor_setup/views/unit-of-measure/UoM";
import ScheduleTaggingScreen from "./doctor_setup/views/medicine-schedules/ScheduleTaggingScreen";
import ComplianceTracker from "./doctor_setup/views/medicine-schedules/ComplianceTrackingScreen";
import MedicineScheduleDashboard from "./doctor_setup/views/medicine-schedules/MedicineScheduleDashboard";
import ReportGenerator from "./doctor_setup/views/medicine-schedules/ReportGenerator";
import IntegrationGuidelines from "./doctor_setup/views/medicine-schedules/IntegrationGuidelines";
import MedicineSchedulePage from "./doctor_setup/views/medicine-schedules/MedicineSchedulePage";
import ItemMaster from "./doctor_setup/views/ItemMaster";
import PharmacyOnboarding from "./components/authentication/view/PharmacyOnboarding";
import { useEffect, useState } from "react";
import LinkedDoctorPharmacy from "./doctor_setup/views/linked-doctor-pharmacy/LinkedDoctorPharmacy";
import WardDashboard from "./ward-management-master/views/WardDashboard";
import WardDetail from "./ward-management-master/views/WardDetail";

export default function UserRouting() {
  const { role_name } = useCurrentRole();
  const { isReminder, setShowPopup, popupTask } = useReminder();
  const isAuthenticated = Boolean(localStorage.getItem("access_token"));
  const [selectedOption, setSelectedOption] = useState("cufront"); // Default to clinic
  //

  // Determine the default selection based on the subdomain
  useEffect(() => {
    const hostname = window.location.hostname; // Get current domain
    const subdomain = hostname.split(".")[0]; // Extract subdomain

    if (
      subdomain.includes("pharmacy") ||
      ["venus-pharmacy", "moon-pharmacy"].includes(subdomain)
    ) {
      setSelectedOption("pharmacy");
    } else if (
      subdomain.includes("doctor") ||
      ["venus", "moon"].includes(subdomain)
    ) {
      setSelectedOption("cufront");
    }
  }, []);

  return (
    <>
      <div className="bg-white">
        {isReminder && (
          <RemainderPopup
            task={popupTask}
            onClose={() => setShowPopup(false)}
          />
        )}
        <Routes>
          <Route
            path="/login"
            element={
              isAuthenticated ? (
                <Navigate
                  to={
                    role_name === "tv_view"
                      ? "/new/clinicshow"
                      : selectedOption === "pharmacy"
                        ? "/new/pharmacy"
                        : "/new/appointment?all_clinic=false&view=day&session=All"
                  }
                />
              ) : (
                <Authentication />
              )
            }
          />

          <Route
            path="/"
            element={
              <Navigate
                to={
                  !localStorage.getItem("access_token")
                    ? "/login"
                    : role_name === "tv_view"
                      ? "/new/clinicshow"
                      : "/new/appointment?all_clinic=false&view=day&session=All"
                }
              />
            }
          />
          <Route
            path="/onboarding-pharmacy"
            element={<PharmacyOnboarding />}
          ></Route>
          <Route
            path="/new"
            element={<ProtectedRoute Cmp={AvailibilityTest} />}
          >
            <Route path="clinicshow" element={<FrontDeskView />} />
            <Route path="mynotes" element={<MyNotes />} />
            <Route path="editprofile" element={<Profile />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="appointment" element={<Appointment />} />
            <Route path="invoice" element={<InvoiceMain />} />
            <Route path="create_invoice" element={<InvoiceForm />} />
            <Route path="setup" element={<DrSetup />} />

            <Route path="setup/customersetup" element={<CustomerSetupMain />} />
            <Route path="setup/item" element={<ItemMasterWrapper />} />
            <Route path="setup/item/:id" element={<ItemMaster />} />
            <Route path="setup/custom-fields" element={<CustomFields />} />
            {/* <Route path="setup/pharmacy-setup" element={<PharmacySetup />} /> */}
            <Route path="setup/vendor" element={<VendorMaster />} />
            <Route path="setup/warehouse" element={<PharmacyWrapper />} />
            <Route path="setup/warehouse/:id" element={<PharmacyForm />} />
            <Route
              path="setup/rack-management/:id"
              element={<POSDashboard />}
            />
            <Route path="setup/workflow" element={<WorkflowList />} />
            <Route path="setup/workflow/:id" element={<WorkflowSetup />} />
            <Route
              path="setup/preconsultation"
              element={<QuestionnaireManager />}
            />
            <Route path="setup/uom" element={<UoM />} />
            <Route
              path="setup/linked-doctors"
              element={<LinkedDoctorPharmacy />}
            />
            <Route path="setup/ward-management" element={<WardDashboard />} />
            <Route
              path="setup/ward-management/:wardId"
              element={<WardDetail />}
            />
            <Route
              path="setup/medicine-schedules"
              element={<MedicineScheduleDashboard />}
            />
            <Route
              path="setup/medicine-schedules/schedule-tagging"
              element={<MedicineSchedulePage />}
            />
            <Route
              path="setup/medicine-schedules/compliance-tracking"
              element={<ComplianceTracker />}
            />
            <Route
              path="setup/medicine-schedules/reports"
              element={<ReportGenerator />}
            />
            <Route
              path="setup/medicine-schedules/integration"
              element={<IntegrationGuidelines />}
            />

            <Route path="pharmacy" element={<PharmacyOperationWrapper />} />
            <Route path="pharmacy/receipt/create" element={<CreateReceipt />} />
            <Route path="pharmacy/receipt/:id" element={<ReceiptDetail />} />
            <Route
              path="pharmacy/prescription/:id"
              element={<PrescriptionDetail />}
            />
            <Route path="pharmacy/bill/create/:id" element={<CreateBill />} />
            <Route path="notifications" element={<Notification />} />
            <Route path="settings" element={<Settings />} />
            <Route path="settings/help-center" element={<HelpCenter />} />
            <Route
              path="settings/help-center/form"
              element={<HelpCenterForm />}
            />
            <Route path="settings/help-center/ticket" element={<Tickets />} />
            <Route path="chat" element={<SomethingWentWrong />} />
            <Route path="all-patient" element={<AllPatient />} />
            <Route path="records" element={<Records />} />
            <Route path="patient-options" element={<ConsultationLeftBar />} />
            <Route path="registration" element={<PatientRegistration />} />
            <Route path="emergency" element={<Emergency />} />
            {/* <Route path="pharmacy" element={<Pharmacy />} /> */}
            <Route path="ipd" element={<IpdManagement />} />
            <Route path="ward/:id" element={<WardDetails />} />
            <Route
              path="treatment-tracker/:id"
              element={<TreatmentTracker />}
            />

            <Route
              path="patient/dashboard/:id"
              element={<PatientDetailManagement />}
            />
            <Route path="discharge/:id" element={<DischargeWorkflow />} />
            <Route path="procedure-setup" element={<ProcedureMaster />} />
          </Route>
        </Routes>
      </div>
    </>
  );
}
